import OPERATION_REORDER_COLUMN from './sortReOrder.column';
import SORT_FIELD_COLUMN from './sortField.column';
import SORT_PREFERENCE_COLUMN from './sortOrder.column';
export default [OPERATION_REORDER_COLUMN, SORT_FIELD_COLUMN, SORT_PREFERENCE_COLUMN];